import { useRef as e, useCallback as o } from "react";
var r = function () {
  var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
    n = e(new Map()),
    t = r.behavior,
    i = void 0 === t ? "smooth" : t,
    l = r.block,
    a = void 0 === l ? "start" : l,
    c = r.inline,
    f = void 0 === c ? "nearest" : c,
    v = r.offset,
    d = void 0 === v ? 0 : v,
    s = o(function (e, o) {
      o ? n.current.set(e, o) : n.current.delete(e);
    }, []),
    u = o(function (e) {
      var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = n.current.get(e);
      if (r) {
        var t = {
          behavior: o.behavior || i,
          block: o.block || a,
          inline: o.inline || f
        };
        if (o.offset || d) {
          var l = r.getBoundingClientRect().top,
            c = l + window.pageYOffset - (o.offset || d);
          window.scrollTo({
            top: c,
            behavior: t.behavior
          });
        } else r.scrollIntoView(t);
        return !0;
      }
      return !1;
    }, [i, a, f, d]),
    h = o(function (e) {
      var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = document.querySelectorAll('[id="'.concat(e, '"]')),
        n = Array.from(r).find(function (e) {
          var o = window.getComputedStyle(e);
          return "none" !== o.display && "hidden" !== o.visibility && null !== e.offsetParent;
        }) || r[0];
      if (n) {
        var t = {
          behavior: o.behavior || i,
          block: o.block || a,
          inline: o.inline || f
        };
        if (o.offset || d) {
          var l = n.getBoundingClientRect().top,
            c = l + window.pageYOffset - (o.offset || d);
          window.scrollTo({
            top: c,
            behavior: t.behavior
          });
        } else n.scrollIntoView(t);
        return !0;
      }
      return !1;
    }, [i, a, f, d]);
  return {
    registerAnchor: s,
    scrollToAnchor: u,
    scrollToAnchorById: h
  };
};
export { r as default };